import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ReportNewService } from './report-new.service';

@Injectable({
    providedIn: 'root',
})
export class AllowOnlyPartnerListGuardService implements CanActivate {
    constructor(
        private router: Router,
        private reportNewService: ReportNewService,
    ) { }

    public canActivate(): Observable<boolean> {
        return this.reportNewService.isAllowed()
            .pipe(
                map((response: boolean) => {
                    if (!response) {
                        this.router.navigate(['page-forbidden']);
                    }

                    return response;
                }),
            );
    }
}
